import React, { Component } from 'react';

import './TextButton.css'

export class TextButton extends Component {
    render() {
        return (
            <div className='textButton' 
            style={{ 
                width: this.calculateWidth(this.props.data) || '35px', 
                height: this.calculateHeight(this.props.data) || '35px',
                // lineHeight: `${this.calculateHeight(this.props.data) ? this.calculateHeight(this.props.data)-8 : 35}px`
            }}
            onClick={this.props.onClick}>
                <span>{this.props.data.text}</span>                
            </div>
        );
    }

    calculateWidth(param) {
        let sizeOfSingleCharacter = param.fontSize;
        let length = param.text.length;
        let res = sizeOfSingleCharacter;
        try {
            if (sizeOfSingleCharacter.indexOf("rem") > 0) {
                sizeOfSingleCharacter = sizeOfSingleCharacter.replace("rem", "");
                res = `${this.convertRemToPixels(Number(sizeOfSingleCharacter))*length*2}px`;
            } else if (sizeOfSingleCharacter.indexOf("px") > 0){
                sizeOfSingleCharacter = sizeOfSingleCharacter.replace("px", "");
                res = `${Number(sizeOfSingleCharacter)*length*2}px`;
            } else {
                res = `${Number(sizeOfSingleCharacter)*length*2}px`;
            }
        }
        catch(ex) {
            res = null;
        }        

        return res;
    }

    calculateHeight(param) {
        let sizeOfSingleCharacter = param.fontSize;
        let res = sizeOfSingleCharacter;
        try {
            if (sizeOfSingleCharacter.indexOf("rem") > 0) {
                sizeOfSingleCharacter = sizeOfSingleCharacter.replace("rem", "");
                res = `${this.convertRemToPixels(Number(sizeOfSingleCharacter))*2}px`;
            } else if (sizeOfSingleCharacter.indexOf("px") > 0){
                sizeOfSingleCharacter = sizeOfSingleCharacter.replace("px", "");
                res = `${Number(sizeOfSingleCharacter)*2}px`;
            } else {
                res = `${Number(sizeOfSingleCharacter)*2}px`;
            }
        }
        catch(ex) {
            res = null;
        }     
        return res;
    }

    convertRemToPixels(rem) {    
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    }
}